import React from 'react'
import Layout from '../../Layout'
import PublicDiscountListContainer from '../../../../Components/DiscountPart/PublicDiscountListContainer/PublicDiscountListContainer'

const PublicDiscountList = () => {
  return (
    <Layout><PublicDiscountListContainer/></Layout>
  )
}

export default PublicDiscountList